export enum StageType {
    NOT_SET = "NOT_SET",
    PHASE = "PHASE",
    LIVE = "LIVE"
}
